import { LoadablePaint } from '@confluence/loadable';

export const LazyTemplatesAndBlueprintsPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TemplatesAndBlueprintsContainer" */ '../src/TemplatesAndBlueprints/TemplatesAndBlueprintsPage'
			)
		).TemplatesAndBlueprintsPage,
});
